var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.2 3.32083C1.2 3.81789 1.60294 4.22083 2.1 4.22083H2.43652H13.5229H13.8593C14.3564 4.22083 14.7593 3.81789 14.7593 3.32083V2.1C14.7593 1.60294 14.3564 1.2 13.8593 1.2H2.1C1.60294 1.2 1.2 1.60294 1.2 2.1V3.32083ZM14.1229 5.40445C15.1583 5.2748 15.9593 4.39136 15.9593 3.32083V2.1C15.9593 0.940201 15.0191 0 13.8593 0H2.1C0.940201 0 0 0.940202 0 2.1V3.32083C0 4.39139 0.801088 5.27485 1.83652 5.40446V13.399C1.83652 14.8349 3.00058 15.999 4.43652 15.999H11.5229C12.9588 15.999 14.1229 14.8349 14.1229 13.399V5.40445ZM12.9229 5.42083H3.03652V13.399C3.03652 14.1722 3.66332 14.799 4.43652 14.799H11.5229C12.2961 14.799 12.9229 14.1722 12.9229 13.399V5.42083ZM6.75435 8.24154C6.75435 7.91017 6.48572 7.64154 6.15435 7.64154C5.82298 7.64154 5.55435 7.91017 5.55435 8.24154V11.9782C5.55435 12.3096 5.82298 12.5782 6.15435 12.5782C6.48572 12.5782 6.75435 12.3096 6.75435 11.9782V8.24154ZM9.80402 7.64154C10.1354 7.64154 10.404 7.91017 10.404 8.24154V11.9782C10.404 12.3096 10.1354 12.5782 9.80402 12.5782C9.47265 12.5782 9.20402 12.3096 9.20402 11.9782V8.24154C9.20402 7.91017 9.47265 7.64154 9.80402 7.64154Z",
    fill: "#EE0202"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.55e86075.svg";
export { ForwardRef as ReactComponent };